import { inject, Injectable } from '@angular/core';

import { map, Observable } from 'rxjs';

import { ID } from '@core/ngrx-legacy';
import { TellentHttpApiService } from '@core/tellent-http-legacy';
import { TellentPosition, TellentPositionResponse } from '@core/tellent-positions-types';
import { ORG_GUID } from '@core/tellent-types';

@Injectable({
  providedIn: 'root',
})
export class TellentPositionsHttpClient {
  private readonly httpApi = inject(TellentHttpApiService);
  private readonly orgGuid = inject(ORG_GUID);

  public fetchPositions(): Observable<TellentPosition[]> {
    return this.httpApi
      .get(`/positions/org/${this.orgGuid}/positions`, null, { skipCompany: true })
      .pipe(map(response => response.data));
  }

  public createPosition(name: string): Observable<TellentPosition> {
    return this.httpApi
      .post(`/positions/org/${this.orgGuid}/positions`, null, { name }, { skipCompany: true })
      .pipe(map(response => response.position));
  }

  public fetchPosition(positionGuid: ID | string): Observable<TellentPositionResponse> {
    return this.httpApi
      .get(`/positions/org/${this.orgGuid}/positions/${positionGuid}`, null, { skipCompany: true })
      .pipe(map(response => ({ data: response.position })));
  }
}
